import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ButtonControl from "../../../../Controls/ButtonControl"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	const [getServiceIframeResult, setServiceIframeResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowCertificateDraftReview", inputValue, ShowServiceResultSuccess);
    }, []);	
	
    const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }

	const PrintCertificateDraftReview=()=>{
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/PrintCertificateDraftReview", inputValue, PrintCertificateDraftReviewSuccess);
	}	

	const PrintCertificateDraftReviewSuccess =(ServiceResult)=>{
		setServiceIframeResult(ServiceResult);
	}		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
				<tbody>
						<tr>
							<td><b class="b1">شماره گواهی:</b> {getServiceResult.CertificateNumber}</td>
							<td><b class="b1">تاریخ صدور:</b> {getServiceResult.IssueDate}</td>
							<td><b class="b1">مرحله ساختمانی:</b> {getServiceResult.BuildingStage}</td>
						</tr>
						<tr>
							<td><b class="b1">کاربری زمین:</b> {getServiceResult.LandUsage}</td>
							<td><b class="b1">نوع اسکلت:</b> {getServiceResult.BuildingStructure}</td>
							<td><b class="b1">تراکم زمین:</b> {getServiceResult.Density}</td>
						</tr>
						<tr>
							<td><b class="b1">مساحت طبق سند:</b> {getServiceResult.AreaByDocument}</td>
							<td><b class="b1">مساحت پس از اصلاحی:</b> {getServiceResult.AreaAfterCorrection}</td>
							<td colsapn="2"><b class="b1">حق انتقال به غیر:</b> {getServiceResult.IsTransferable}</td>
						</tr>
						<tr>
							<td><b class="b1">نوع گواهی:</b> {getServiceResult.CertificateType}</td>
							<td colspan="2"><b class="b1">مهندس ناظر:</b> {getServiceResult.SupervisorEngineer}</td>
						</tr>	
						<tr>
							<td colspan="3"><b class="b1">توضیح پیش نویس:</b> {getServiceResult.DraftDescription}</td>
						</tr>
						<br/>	
						<tr>
							<td colspan="7" className="text-end">
								<ButtonControl 
									variant="primary float-left w-25 mx-2"
									title="نمایش گواهی"
									onClick={PrintCertificateDraftReview}
									icon="fa fa-file-pdf-o"
								/>						
							</td>
						</tr>						
				</tbody>	
			</table>
			{getServiceIframeResult != false && <iframe src={"data:application/pdf;base64,"+getServiceIframeResult} width="100%" height="600"></iframe> }	
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>			
    );
}
